/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BannerBanneridLangsAvailableLanguages200,
  GetApiV1BannerBanneridLangsAvailableLanguages401,
  GetApiV1BannerBanneridLangsAvailableLanguages404,
  GetApiV1BannerBanneridLangsAvailableLanguages500,
  GetApiV1BannerBanneridLangsAvailableLanguagesPathParams,
  GetApiV1BannerBanneridLangsAvailableLanguagesQueryResponse,
} from "../../types/bannerIdiomasController/GetApiV1BannerBanneridLangsAvailableLanguages.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";

export const getApiV1BannerBanneridLangsAvailableLanguagesPathParamsSchema =
  z.object({
    bannerId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1BannerBanneridLangsAvailableLanguagesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BannerBanneridLangsAvailableLanguages200Schema = z.array(
  z.lazy(() => dropDownListStringKeyViewModelSchema),
) as unknown as ToZod<GetApiV1BannerBanneridLangsAvailableLanguages200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BannerBanneridLangsAvailableLanguages401Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBanneridLangsAvailableLanguages401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1BannerBanneridLangsAvailableLanguages404Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBanneridLangsAvailableLanguages404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BannerBanneridLangsAvailableLanguages500Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBanneridLangsAvailableLanguages500>;

export const getApiV1BannerBanneridLangsAvailableLanguagesQueryResponseSchema =
  z.lazy(
    () => getApiV1BannerBanneridLangsAvailableLanguages200Schema,
  ) as unknown as ToZod<GetApiV1BannerBanneridLangsAvailableLanguagesQueryResponse>;
